import "core-js/modules/es.array.for-each";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import comp from './comp/index';
export default {
  meta: {
    title: '订单查询与跟踪',
    auth: true,
    authorityValue: "store-order-list"
  },
  name: 'orderSearch',
  components: _objectSpread({}, comp),
  data: function data() {
    return {
      activeName: 'orderAll',
      tab: [{
        id: 0,
        label: '全部订单',
        type: 'orderAll',
        key: 'orderCount'
      }, {
        id: 1,
        label: '待付款',
        type: 'stayPay',
        key: 'newOrderCount'
      }, {
        id: 2,
        label: '待出库',
        type: 'stayHouse',
        key: 'paidCount'
      }, {
        id: 3,
        label: '已出库',
        type: 'inHouse',
        key: 'deliveryCount'
      }, {
        id: 4,
        label: '已完成',
        type: 'inSuccess',
        key: 'completeCount'
      }, {
        id: 5,
        label: '已取消',
        type: 'inError',
        key: 'cancelCount'
      }]
    };
  },
  created: function created() {
    var query = this.$route.query;
    if (query.activeName) this.activeName = query.activeName;
    this.getOrderCount();
  },
  methods: {
    getOrderCount: function getOrderCount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.orderCount();

              case 2:
                data = _context.sent;

                _this.tab.forEach(function (v, i) {
                  return v['num'] = data[v.key];
                });

                _this.$forceUpdate();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    tabClick: function tabClick(l) {
      this.activeName = l.type;
    },
    handleClick: function handleClick(l) {
      this.activeName = l.name;
    }
  }
};